<template>
  <div class="resource_data_schema">
    <div class="form-row">
      <div class="form-group col-12">
        <label>
          {{ $t('resource.dataSchema.identifier') }}
        </label>
        <ValidationProvider
          v-slot="{ classes, errors }"
          ref="dataSchema-identifier"
          :rules="form.schemaVersion || form.schemaFormat ? 'required' : ''"
          :name="`Identifiant schéma de données ressource`"
        >
          <div
            class="control"
            :class="classes"
          >
            <input
              v-model="form.schemaIdentifier"
              v-sanitize
              class="form-control"
              type="text"
              :placeholder="$t('resource.dataSchema.identifier')"
            >
            <span class="form-errors">{{ errors[0] }}</span>
          </div>
        </ValidationProvider>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-12">
        <label>
          {{ $t('resource.dataSchema.version') }}
        </label>
        <ValidationProvider
          v-slot="{ classes, errors }"
          ref="dataSchema-version"
          :rules="form.schemaIdentifier || form.schemaFormat ? 'required' : ''"
          :name="`Version schéma de données ressource`"
        >
          <div
            class="control"
            :class="classes"
          >
            <input
              v-model="form.schemaVersion"
              v-sanitize
              class="form-control"
              type="text"
              :placeholder="$t('resource.dataSchema.version')"
            >
            <span class="form-errors">{{ errors[0] }}</span>
          </div>
        </ValidationProvider>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-12">
        <label>
          {{ $t('resource.dataSchema.format') }}
        </label>
        <ValidationProvider
          v-slot="{ classes, errors }"
          ref="dataSchema-format"
          :rules="form.schemaIdentifier || form.schemaVersion ? 'required' : ''"
          :name="`Format schéma de données ressource`"
        >
          <div
            class="control"
            :class="classes"
          >
            <input
              v-model="form.schemaFormat"
              v-sanitize
              class="form-control"
              type="text"
              :placeholder="$t('resource.dataSchema.format')"
            >
            <span class="form-errors">{{ errors[0] }}</span>
          </div>
        </ValidationProvider>
      </div>
    </div>
    <div
      class="alert alert-light d-flex align-items-center mb-0"
      style="font-size: 0.9rem;"
      role="alert"
    >
      <i
        class="bi bi-info-circle-fill"
        style="margin-right: 1em;"
      />
      <a
        href="https://schema.data.gouv.fr/"
        target="blank"
        class="alert-link"
      >
        {{ $t('resource.dataSchema.infoLink') }}
      </a>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, extend, configure } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

extend('required', {
  ...required,
  message: 'Ce champ est requis'
});
configure({
  classes: {
    valid: 'is-valid',
    invalid: 'is-invalid'
  }
});

export default {
  name: 'ResourceDataSchema',

  components: {
    ValidationProvider
  },

  props: {
    schemaData: {
      type: Object,
      default: () => {
        return {
          schemaIdentifier: null,
          schemaVersion: null,
          schemaFormat: null
        };
      }
    },
  },

  data() {
    return {
      form: {
        schemaIdentifier: null,
        schemaVersion: null,
        schemaFormat: null
      }
    };
  },

  watch: {
    form: {
      deep: true,
      handler(newValue) {
        this.$emit('set', {
          form: newValue,
        });
      }
    }
  },

  created() {
    this.form.schemaIdentifier = this.schemaData.schemaIdentifier;
    this.form.schemaVersion = this.schemaData.schemaVersion;
    this.form.schemaFormat = this.schemaData.schemaFormat;
  },
};
</script>
